module.exports = __webpack_public_path__ + "media/discovery-ui/assets/drop-placeholder-cd571a43542f8d9b97861014317a817e.svg";